module.exports = __webpack_public_path__ + "static/Synchronised_Development_Operations-12c7c2d3b46140b4d894da5f85bd2a1e.svg";